<template>
<div>
  <div class="back-owl d-none d-sm-block">
  <div class="border">
 <carousel>
    <img src="@/assets/img/img.jpg">

    <img src="@/assets/img/img4.jpg">

    <img src="@/assets/img/img2.jpg">

     <img src="@/assets/img/img5.jpg">

</carousel>
    </div>
  </div>
</div>
</template>

<script>
import carousel from 'vue-owl-carousel'
export default {
  name: 'owlCarosel',
  components: { carousel }
}
</script>
